<template>
  <NavbarApp />

  <div class="about-page-container">
    <!-- Intro Section -->
    <section class="about-section about-intro-section fade-up">
      <h2 class="section-subtitle intro-title">
        <i18n-t keypath="about.title1">
          <template #companyName>{{ $t('companyName') }}</template>
        </i18n-t>
      </h2>
      <p class="intro-description">
        {{ $t('about.description1') }}
      </p>
    </section>

    <!-- Our Story Section -->
    <section class="about-section about-story-section fade-up">
      <h2 class="section-subtitle">
        <i18n-t keypath="about.title2">
          <template #companyName>{{ $t('companyName') }}</template>
        </i18n-t>
      </h2>
      <p class="intro-description">
        {{ $t('about.description2') }}
      </p>
    </section>
  </div>

  <!-- Background -->
  <div class="image-background">
    <img
      alt="expertise-background"
      src="../assets/image/background.jpg"
      class="background-image"
    />
  </div>

  <!-- Extra Section -->
  <Section4 />
</template>

<script>
import NavbarApp from '../components/HomePage/navbar-law.vue';
import Section4 from '../components/HomePage/section-4.vue';

export default {
  name: 'AboutPage',
  components: {
    NavbarApp,
    Section4,
  },
  mounted() {
    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry, index) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              entry.target.classList.add('show');
            }, index * 120);
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    document.querySelectorAll('.fade-up').forEach((el) => observer.observe(el));
    const bgImage = document.querySelector('.background-image');
    if (bgImage) observer.observe(bgImage);
  },
};
</script>

<style scoped>
/* --- Scroll Animations for Sections --- */
.fade-up {
  opacity: 0;
  transform: translateY(40px);
  transition: opacity 0.8s ease, transform 0.8s ease;
}
.fade-up.show {
  opacity: 1;
  transform: translateY(0);
}

/* --- Background Image (unchanged) --- */
.background-image {
  position: absolute;
  overflow: hidden;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0;
  z-index: -2;
  transform: scale(1.1) translateY(-100%);
  transition: opacity 1.2s ease, transform 1.2s ease;
  
}
.background-image.show {
  opacity: 0.2;
  transform: scale(1) translateY(-100%);
}

/* --- Page Container --- */
.about-page-container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 40px 20px;
  color: #333;
  position: relative;
  z-index: 1;
}

/* --- Sections --- */
.about-section {
  margin-bottom: 80px;
  padding-left: 25px;
  border-left: 4px solid #bbd55a;
  transition: transform 0.3s ease;
  text-align: justify;
  text-justify: inter-word;
}
.about-section:hover {
  transform: translateX(6px);
}

.about-intro-section {
  padding-top: 20px;
}

.about-story-section,
.about-vision-section {
  max-width: 900px;
}

/* --- Typography --- */
.section-title {
   font-size: 2rem;
  font-weight: 600;
  color: #2c3e50;
  line-height: 1.1;
  margin-bottom: 25px;
}

.section-title::after {
  content: '';
  display: block;
  margin-top: 10px;
  height: 3px;
  width: 40px;
  background-color: #bbd55a;
  transition: width 0.4s ease;
}

.fade-up.show .section-title::after {
  width: 70px;
}

.intro-title {
  
  margin-bottom: 35px;
}

.section-subtitle {
  font-size: 2rem;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 20px;
  position: relative;
}
.section-subtitle::after {
  content: '';
  display: block;
  margin-top: 10px;
  height: 3px;
  width: 40px;
  background-color: #bbd55a;
  transition: width 0.4s ease;
}
.fade-up.show .section-subtitle::after {
  width: 70px;
}

.intro-description {
  font-size: 1.3rem;
  color: #555;
  line-height: 1.7;
  max-width: 900px;
  margin: 0;
}

.story-paragraph,
.vision-paragraph {
  font-size: 1.1rem;
  color: #666;
  line-height: 1.8;
  margin-bottom: 20px;
  max-width: 800px;
}

/* --- Responsive Breakpoints --- */
@media (max-width: 1024px) {
  .section-title {
    font-size: 3.2rem;
  }
  .intro-title {
    font-size: 3.6rem;
  }
  .section-subtitle {
    font-size: 1.8rem;
  }
  .intro-description {
    font-size: 1.15rem;
  }
}

@media (max-width: 767px) {
  .about-section {
    margin-bottom: 50px;
    border-left: 3px solid #bbd55a;
    padding-left: 15px;
  }
  .section-title {
    font-size: 2.5rem;
  }
  .intro-title {
    font-size: 3rem;
  }
  .section-subtitle {
    font-size: 1.5rem;
  }
  .intro-description {
    font-size: 1rem;
  }
}
</style>
